<template>
    <div class="history__cas-entry">
        <main id="history__cas-container" :data-mfe-id="appName" />
    </div>
</template>

<script>
import { psAxios } from '@patsnap/common-ps-http';
import { loadMicroApp, prefetchApps } from 'qiankun';

window.qiankunSingleton = window.qiankunSingleton || {
    loadMicroApp,
    prefetchApps,
};

export default {
    name: 'HistoryCASContainer',
    data() {
        return {
            appName: ''
        };
    },
    created() {
        this.appName = `cas-history.patsnap`;
    },
    mounted() {
        const mfeEntry = `${process.env['VUE_APP_STATIC_COMMON_URL']}/micro-cas-patent-view-plugins/history.html`;
        // const mfeEntry = 'http://localhost:9001/micro-cas-patent-view-plugins/1.1.0/history.html';

        const container = `[data-mfe-id="${this.appName}"]`;
        const appRoutePathBase = process.env.NODE_ENV === 'production' ? '/history/#/' : '/';

        this.micro = window.qiankunSingleton.loadMicroApp({
            name: this.appName,
            entry: mfeEntry,
            container: this.$el.querySelector(container),
            props: {
                lang: this.$i18n.locale,
                routeBaseUrl: appRoutePathBase,
                psAxios,
            },
        });
    },
    beforeDestroy() {
        this.micro ? this.micro.unmount() : null;
    }
};
</script>

<style lang="scss">
.history__cas-entry {
    height: calc(100vh - 64px);
    width: 100%;
    display: block;
    position: relative;
}
#history__cas-container {
    height: 100%;
    div[data-name="cas-history.patsnap"] {
        height: 100%;
    }
}
</style>
